import {Logger} from '../Logging/Logger';

export const logError = (...e: unknown[]) => {
  e.forEach((error) => {
    if (error instanceof Error) {
      Logger.trackException(error);

      return;
    }
    if (typeof error === 'object') {
      Logger.logEvent(JSON.stringify(error));

      return;
    }

    if (typeof error === 'string' || typeof error === 'number' || typeof error === 'boolean') {
      Logger.logEvent(error?.toString());
    }
  });

  /* tslint:disable-next-line:no-console */
  console.error(e);
};

export const logInfo = (...e: unknown[]) => {
  // tslint:disable-next-line:no-console
  console.info(e);
};

export const AssertionException = (message: string) => new Error(`Assertion exception: ${message}`);

export const ConversionException = (message: string) => new Error(`Conversion exception: ${message}`);

export const NotImplementedException = (message: string) => new Error(`Not implemented exception: ${message}`);
